import { useEffect, useState } from "react";
import api from "@/lib/api";
import { money, dateShort } from "@/lib/format";
import { StatusBadge } from "@/components/StatusBadge";

export const FirstCreditedSale = () => {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/admin/votel/first-credited").then((r) => setD(r.data)).catch(() => setD({ found: false }));
  }, []);
  if (!d) return null;
  return (
    <div className="rounded-sm border border-border bg-card p-5" data-testid="first-credited-card">
      <h3 className="font-heading font-semibold">First credited sale</h3>
      <p className="mb-3 text-xs text-muted-foreground">Confirm this before switching on sale alerts.</p>
      {!d.found ? (
        <div className="text-sm text-muted-foreground" data-testid="first-credited-empty">No Votel sale has been credited to a rep yet.</div>
      ) : (
        <div className="grid grid-cols-2 gap-3 text-sm md:grid-cols-5" data-testid="first-credited-details">
          <div><div className="overline">Rep</div><div data-testid="first-credited-rep">{d.rep_name}</div></div>
          <div><div className="overline">Buyer</div><div>{d.buyer || "—"}</div></div>
          <div><div className="overline">Product</div><div className="font-mono text-xs">{d.product_name}</div><div className="font-mono text-xs text-muted-foreground">{money(d.amount)} · {dateShort(d.charged_at)}</div></div>
          <div><div className="overline">Commission</div><div className="font-mono text-lg" data-testid="first-credited-commission">{d.commission_amount == null ? "not booked yet" : money(d.commission_amount)}</div></div>
          <div><div className="overline">Status</div>{d.commission_status ? <StatusBadge status={d.commission_status} /> : "—"}<div className="mt-1 text-xs text-muted-foreground">{d.status === "assigned" ? "manually assigned" : "auto by product"}</div></div>
        </div>
      )}
    </div>
  );
};
